// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"006169f8","511":"a1bb758b","767":"65ad6a3f"}[chunkId] + ".chunk.js";
};